/**
 * Created by RUSS_ on 15.05.2018
 */
export let api = {
  /**
   * function with these options = {
        preferencesButton: true,
        preferencesButtonPosition: "bottom left"
     }
     will be @override
   */
  init: null,
  /**
   * a wrapper to avoid incompatibility problems
   */
  dispatch: (fnct, ...args) => {
    if (typeof this[fnct] === "function") {
      this[fnct](args);
    }
  },

  /**
   * checks whether a certain cookie is accepted, by its id
   * will be @override
   */
  isCookieAccepted: null
};

// provide api in global scope. Don't override it, if already exist from prefly script
if (window.RussCityCookieManager) {
  api = Object.create(window.RussCityCookieManager);
}
window.RussCityCookieManager = api;



// WEBPACK FOOTER //
// ./src-cookie-manager/managers/api-manager.js